import { useState, useEffect, useRef } from "react";

const useTypingEffect = (message, speed = 30) => {
    const [displayed, setDisplayed] = useState("");
    const [isDone, setIsDone] = useState(false);
    const intervalRef = useRef(null);
    const indexRef = useRef(0);

    useEffect(() => {
        if (!message) return;

        setDisplayed("");
        setIsDone(false);
        indexRef.current = 0;

        if (intervalRef.current) clearInterval(intervalRef.current);

        intervalRef.current = setInterval(() => {
            indexRef.current += 1;
            setDisplayed(message.slice(0, indexRef.current));

            if (indexRef.current >= message.length) {
                clearInterval(intervalRef.current);
                setIsDone(true);
            }
        }, speed);

        return () => clearInterval(intervalRef.current);
    }, [message, speed]);

    return { displayed, isDone };
};

export default useTypingEffect;